import React from 'react';
import PropTypes from 'prop-types';
import { Button, Header, Modal } from 'semantic-ui-react';
import { FloatingLabelInput as Input } from '../../Elements';
import { GlobalNotifications, Intent } from '../../Modules';
import Formsy from 'formsy-react';
import styles from '../Event.scss';

export default class NewWorkspace extends React.Component {

  static propTypes = {
    createWorkspace: PropTypes.func.isRequired,
    handleNewWorkspaceTitleChange: PropTypes.func.isRequired,
    newWorkspaceModalOpen: PropTypes.bool.isRequired,
    newWorkspaceTitle: PropTypes.string.isRequired,
    closeNewWorkspaceModal: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.onValidWorkspaceSubmit = this.onValidWorkspaceSubmit.bind(this);
    this.onInvalidWorkspaceSubmit = this.onInvalidWorkspaceSubmit.bind(this);
  }

  onValidWorkspaceSubmit() {
    this.props.createWorkspace();
  }

  onInvalidWorkspaceSubmit() {
    GlobalNotifications.show({
      message: 'Unable to create workspace',
      intent: Intent.DANGER
    });
  }

  render() {
    return (
      <Modal
        open={this.props.newWorkspaceModalOpen}
        onClose={this.props.closeNewWorkspaceModal}
        size='small'
      >
        <Header content='New workspace' />
        <Modal.Content>
          <Formsy.Form
            ref='newWorkspaceForm'
            onValidSubmit={this.onValidWorkspaceSubmit}
            onInvalidSubmit={this.onInvalidWorkspaceSubmit}
          >
            <div>
              <p>
                Create a workspace where you can collaborate
                with your client, team, or other vendors. You
                can upload files or add estimates and
                they&apos;ll be visible to the people you share
                this workspace with.
              </p>
              <Input
                autoFocus
                label='Workspace Title'
                type='text'
                name='title'
                fluid
                autoComplete='off'
                value={this.props.newWorkspaceTitle}
                onChange={this.props.handleNewWorkspaceTitleChange}
                required
                validationError='Workspace title is required'
              />
            </div>
          </Formsy.Form>
        </Modal.Content>
        <Modal.Actions>
          <a
            onClick={this.props.closeNewWorkspaceModal}
            className={styles.modalCancel}
          >
            Cancel
          </a>
          <Button
            primary
            type='submit'
            onClick={() => {
              this.refs.newWorkspaceForm.submit();
            }}
            content='Create Workspace'
            disabled={this.props.newWorkspaceTitle === ''}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/NewWorkspace.js